import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import { ViewProfile } from "./ViewProfile";
import { EditProfile } from "./EditProfile";

interface ProfileDrawerProps {
  open: boolean;
  onClose: () => void;
}

export function ProfileDrawer({ open, onClose }: ProfileDrawerProps) {
  const [isEdit, setIsEdit] = useState(false);

  const handleClose = () => {
    setIsEdit(false);
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      slotProps={{ paper: { sx: { width: "100%", maxWidth: 448 } } }}
    >
      <h2 className="sr-only">My account</h2>
      <p className="sr-only">
        View or edit your account details and manage active sessions
      </p>
      {isEdit ? (
        <EditProfile onDone={handleClose} onBack={() => setIsEdit(false)} />
      ) : (
        <ViewProfile onEdit={() => setIsEdit(true)} onClose={handleClose} />
      )}
    </Drawer>
  );
}
